require('./template/multiSelectButton.tpl.html');
require('./template/multiSelectHeader.tpl.html');
require('./userSelectionModal/userSelectionModalController');
require('./userSelectionModal/userSelectionModal.tpl.html');
require('./confirmationModal/confirmationModalController');
require('./confirmationModal/confirmationModal.tpl.html');

/*@ngInject*/
const UISubmissionGridMultiSelect = function ($rootScope, $parse, submissionGridConstant, localization) {

    let linkFunction = function ($scope, $elm, $attr) {
        const maxBulkReassignPreference = $parse($attr.multiSelectMaximumBatchSize)($scope);

        $scope.onMultiSelectReassignCallback = $parse($attr.multiSelectReassignCallback)($scope);
        $scope.onMultiSelectResolveCallback = $parse($attr.multiSelectResolveCallback)($scope);

        $scope.multiSelectModel = {
            multiSelectHeaderTitle: $attr['multiSelectTitle'],
            multiSelectCogMenuLabel: $attr['multiSelectCogMenuLabel'],
            showResolveAction: $attr['showResolveAction'] || false,
            isMultiSelectMode: false,
            selectAllCheckbox: false,
            multiSelectItemList: [],
            isMultiSelectUsingExclusion: false,
            maxBulkReassignSubmissions: maxBulkReassignPreference < 1000 ? maxBulkReassignPreference: 1000
        };

        localization.getTranslationByKey('homePage.widgets.submissionGrid.bulkReassign.maximumSelectionWarning').then((result) => {
            $scope.multiSelectModel.maximumSelectionWarning = result;
        });

        $scope.multiSelectUtil = {

            onBeginMultiSelect: function () {
                $scope.multiSelectModel.isMultiSelectMode = true;
                $scope.multiSelectModel.multiSelectItemList = [];
                $rootScope.$broadcast(submissionGridConstant.event.CLOSE_SUBMISSION_DETAIL_DRAWER);
            },

            onCancelMultiSelect: function () {
                $scope.multiSelectModel.isMultiSelectMode = false;
                $scope.multiSelectModel.selectAllCheckbox = false;
                $scope.multiSelectModel.isMultiSelectUsingExclusion = false;
                $scope.multiSelectModel.multiSelectItemList = [];
            },

            resetMultiSelect: function () {
                $scope.multiSelectModel.multiSelectItemList = [];
            },

            onToggleSelectAllCheckbox: function () {
                $scope.multiSelectModel.selectAllCheckbox = !$scope.multiSelectModel.selectAllCheckbox;
                $scope.multiSelectModel.multiSelectItemList = [];
                $scope.multiSelectModel.isMultiSelectUsingExclusion = $scope.multiSelectModel.selectAllCheckbox;
            },

            activateSelectAllCheckbox: function () {
                $scope.multiSelectModel.selectAllCheckbox = true;
                $scope.multiSelectModel.multiSelectItemList = [];
                $scope.multiSelectModel.isMultiSelectUsingExclusion = $scope.multiSelectModel.selectAllCheckbox;
            },

            getMultiSelectCount: function () {
                const allItemsSelected = $scope.multiSelectModel.selectAllCheckbox;
                const multiSelectItemListCount = $scope.multiSelectModel.multiSelectItemList.length;
                let total = 0;

                if(allItemsSelected) {
                    total = $scope.$ctrl.totalRecords - multiSelectItemListCount;
                }
                else {
                    total = multiSelectItemListCount;
                }

                return total;
            },

            isRowSelected: function (id) {
                const isAllCheckboxSelected = $scope.multiSelectModel.selectAllCheckbox === true;
                const isRowIdInList = $scope.multiSelectModel.multiSelectItemList.indexOf(id) !== -1;

                let result = false;

                if(isAllCheckboxSelected) {
                    result = isRowIdInList === false;
                }
                else {
                    result = isRowIdInList === true;
                }

                return result;
            },

            handleMultiSelectRowClick: function (selectedItem) {
                const isRowInSelectionList = $scope.multiSelectModel.multiSelectItemList.indexOf(selectedItem.id) !== -1;

                if(!isRowInSelectionList) {
                    $scope.multiSelectModel.multiSelectItemList.push(selectedItem.id);
                }
                else {
                    const selectedItemId = selectedItem.id;
                    const selectedItemIndex = $scope.multiSelectModel.multiSelectItemList.indexOf(selectedItemId);

                    $scope.multiSelectModel.multiSelectItemList.splice(selectedItemIndex, 1);
                }
            },

            isSelectAllCheckboxSelected: function () {
                const isSelectAllCheckboxSelected = $scope.multiSelectModel.selectAllCheckbox;
                const isEntireListSelected = $scope.multiSelectModel.totalRecords === $scope.multiSelectModel.multiSelectItemList.length;

                return isEntireListSelected || isSelectAllCheckboxSelected;
            },

            getMaximumSelectionCountWarning: function () {
                return $scope.multiSelectModel.maximumSelectionWarning.replace('{1}', $scope.multiSelectModel.maxBulkReassignSubmissions.toString());
            },

            isMaximumSelectionCountWarningVisible: function () {
                const selectionLimit = $scope.multiSelectModel.maxBulkReassignSubmissions;
                const totalSelected = $scope.multiSelectUtil.getMultiSelectCount();

                return totalSelected > selectionLimit;
            }
        };
    };

    return {
        link: linkFunction,
        restrict: 'A'
    };
};

angular.module('umCore')
    .directive('uiSubmissionGridMultiSelect', UISubmissionGridMultiSelect);
